export enum CurrentStatusNameEnum {
  "更地" = "更地",
  "古家付" = "古家付",
  "造成中" = "造成中",
  "現況渡し" = "現況渡し",
  "解体更地渡し" = "解体更地渡し",
  "建築中" = "建築中",
  "完成済" = "完成済",
  "空" = "空",
  "使用中" = "使用中",
  "居住中" = "居住中",
  "賃貸中" = "賃貸中",
  "リフォーム中" = "リフォーム中",
  "その他" = "その他"
}
